import {HttpClient, HttpResponse} from '@angular/common/http';
import {ITicket, Ticket} from '../../shared/model/ticket.model';
import {Injectable} from '@angular/core';
import {SERVER_API_URL} from '../../app.constants';
import {Observable} from 'rxjs/index';
import {map} from 'rxjs/internal/operators';
import {createRequestOption} from '../../shared/util/request-util';

type EntityResponseType = HttpResponse<ITicket>;
type EntityArrayResponseType = HttpResponse<ITicket[]>;

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({providedIn: 'root'})
export class TicketService {
  public resourceUrl = SERVER_API_URL + 'api/tickets';

  constructor(protected http: HttpClient) {
  }

  create(ticket: ITicket): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(ticket);
    return this.http
      .post<ITicket>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(ticket: ITicket): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(ticket);
    return this.http
      .put<ITicket>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<ITicket>(`${this.resourceUrl}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  chekForClose(id?: any): Observable<EntityArrayResponseType> {
    return this.http.get<ITicket[]>(this.resourceUrl + '-check-close/' + id, {params: null, observe: 'response'});
  }

  findAllTicketWithCustomerId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(this.resourceUrl + '-customer', {params: options, observe: 'response'});
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(this.resourceUrl, {params: options, observe: 'response'});
  }

  findWithCustomerId(id: number, req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(`${this.resourceUrl + '-find'}/${id}`, {params: options, observe: 'response'});
  }

  getMyOpenTicketCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-my-open'}`, {observe: 'response'});
  }

  getEmployeeOpenTicketCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-employee-open'}`, {observe: 'response'});
  }

  findOpenTicketForClient(id: number, req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(`${this.resourceUrl + '-list-open-client'}/${id}`, {
      params: options,
      observe: 'response'
    });
  }

  findCloseTicketForClient(id: number, req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(`${this.resourceUrl + '-list-close-client'}/${id}`, {
      params: options,
      observe: 'response'
    });
  }

  findOpenTicket(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(`${this.resourceUrl + '-list-open'}`, {params: options, observe: 'response'});
  }

  findCloseTicket(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(`${this.resourceUrl + '-list-close'}`, {params: options, observe: 'response'});
  }

  findAllTicketForClient(id: number, req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITicket[]>(`${this.resourceUrl + '-list-all-client'}/${id}`, {
      params: options,
      observe: 'response'
    });
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  protected convertDateFromClient(ticket: ITicket): ITicket {
    const copy: ITicket = Object.assign({}, ticket, {
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((ticket: ITicket) => {
      });
    }
    return res;
  }


  public exportAsExcelFile(json: any[], excelFileName: string): void {
    //   // alert(' json == ' + json.length);
    //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    //   this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsExcelFile2(json: Ticket[], excelFileName: string): void {
    //   // alert(' json == ' + json.length);
    //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    //   this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    //   const data: Blob = new Blob([buffer], {
    //     type: EXCEL_TYPE
    //   });
    //   FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
